export default __webpack_public_path__ + "images/0x0c4681e6c0235179ec3d4f4fc4df3d14fdd96017.png";